// fiscalValidation.js
//
// Validación en el navegador del identificador tributario (espejo del backend,
// módulo 11). Da feedback inmediato e inline en el wizard; el backend revalida.
//
// El RUT chileno vive en src/utils/rut.js: este archivo nació antes y tenía su
// propia copia del módulo 11, que quedó duplicada. Aquí solo se reexporta.
//
// `export { X } from "...` NO crea un binding local: isValidTaxId llamaba a
// isValidRut y reventaba con ReferenceError en todo país que no fuera AR.
// Por eso se importa y se reexporta por separado.
import { isValidRut } from "../../../../../utils/rut";

export { isValidRut };

// CUIT argentino (11 dígitos, módulo 11).
export function isValidCuit(input) {
  if (!input) return false;
  const digits = String(input).replace(/[-\s.]/g, "");
  if (!/^\d{11}$/.test(digits)) return false;
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i++) sum += Number(digits[i]) * weights[i];
  const mod = 11 - (sum % 11);
  const dv = mod === 11 ? 0 : mod === 10 ? 9 : mod;
  return dv === Number(digits[10]);
}

export function isValidTaxId(country, value) {
  return country === "AR" ? isValidCuit(value) : isValidRut(value);
}

// Los ejemplos deben pasar la propia validación de arriba: si el usuario copia el
// placeholder de un RUT/CUIT con dígito verificador inválido, el formulario lo bloquea.
export const TAX_ID_PLACEHOLDER = { CL: "76.123.456-0", AR: "30-71234567-1" };

export function isEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v ?? "").trim());
}
